package uz.mint.frontend.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.OrderDetailPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.accountStringsFor

/** One purchase in full — Russian, the default locale, at /order. The reference travels as `?ref=`. */
private val LOCALE = Locale.RU

@InitRoute
fun initOrderRoutePage(ctx: InitRouteContext) {
    val account = accountStringsFor(LOCALE)
    ctx.data.add(PageLayoutData(account.orderMetaTitle, LOCALE, account.orderMetaDescription))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun OrderRoutePage() {
    OrderDetailPage(LOCALE)
}
